import React, { useMemo, useRef, useState } from "react";
import styles from "./InputCustom.module.css";
import { useClickOutside } from "@react-hookz/web";
import HighlightedText from "./HighlightedText";
import { Link } from "react-router-dom";
import { routesMap } from "../../routes";
import { Product } from "../../utils/interfaces";

type Props = {
  products: Product[];
};

function InputCustom({ products }: Props) {
  const containerRef = useRef(null);

  // const navigate = useNavigate();
  const [text, setText] = useState("");

  useClickOutside(containerRef, () => {
    setText("");
  });

  const filtered = useMemo(() => {
    return products?.filter(el => el.descrizione.toLowerCase().includes(text.toLocaleLowerCase()));
  }, [products, text]);

  return (
    <div ref={containerRef}>
      <input
        onChange={(e) => setText(e.target.value)}
        className={styles["input-container"]}
        placeholder="Ricerca rapida..."
        value={text}
        style={{
          borderBottomLeftRadius: text && "0",
          borderBottomRightRadius: text && "0",
        }}
      />
      {filtered && text && (
        <ul className={styles["results-container"]}>
          {filtered.map((prod) => {
            return (
              <Link
                key={prod.idProdotto}
                to={`${routesMap.CATALOGO}?prod=${prod.idProdotto}`}
                className={styles["prod"]}
              >
                <li className={styles["item"]}>
                  <HighlightedText text={prod.descrizione} highlight={text} />
                </li>
              </Link>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default InputCustom;
